module.exports = __webpack_public_path__ + "static/lucas_n.0da15360.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/lucas_n.png
// module id = 1717
// module chunks = 35783957827783